import React,{useState} from "react";
import styles from "../../../styles/pages/order.module.scss";
import * as Msal from "msal";
import Image from "next/image";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import endpoints from "../../../utility/endpoints";
import Feedbackmodal from "../Feedback";
import { useRouter } from "next/router";
import SuccessModal from "../../../pages/successModal";
import axios from "axios";
function index(props) {
  const router = useRouter();

  // let ip = "http://20.56.91.182";
  //console.log(props, "props at login");
  const loginData = props.data[0].component.content;

  const [feedbackModal, setFeedbackModal] = React.useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [message, setMessage] = React.useState(
    "We have received your feedback. Thank you for your feedback"
  );
  const [sucessOrFailure, setsucessOrFailure] = React.useState(false);

  const { data } = props;
  const empid = JSON.parse(localStorage.getItem('empid'));
  const orderid = JSON.parse(localStorage.getItem('orderid'));
  const livedate = JSON.parse(localStorage.getItem('livedate'));
  const goTo = (link) => {
    router.push({ 
      pathname:link,
    });
  };
  function openpopup()
  {
    let modal = !feedbackModal;
    setFeedbackModal(true);
    if (modal === true) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }

  const {
    component: {
      content: {
        field_details,
        field_input,
        field_label,
        field_login_image,
        field_logos,
        field_title,
      },
    },
  } = data[0];
const emailHandler = async (e) => {
  let auth = JSON.parse(localStorage.getItem("auth")).data;
  const { data } = await axios({
    url: `${endpoints.baseUrl}/twin/orderMail`,
    method: "POST",
    headers: {
      Authorization: `${auth.accessToken}|${auth.email}`,
    },
    data:{
      orderID:orderid,
    }

  });
  //console.log(data);
  if (data.code === 200) {
    setGlobalskill(data.GlobalSkill);
    setLocalskill(data.LocalSkill);
    setSoftskill(data.softSkill);

  
  }
  else
  {
    console.log("No data found")
  }

}
React.useEffect(() => {
  emailHandler();
},[])
  return (
    <div className={`${styles.Container} container-fluid`}>
      <div className={styles.userLoginContainer}>
        <div className={styles.backimage}>
          <img src="https://bnlwestgunileveraf01091.blob.core.windows.net/botstorevideo/employeetwin/bannerbg.png" alt="" />
        </div>
        <div className={styles.loginModal}>

          <div className={styles.right}>
            <div className={styles.top}>
             
              <div className={styles.textWrapper}>
                <h1 className={styles.head}>{loginData.field_title}</h1>
                <div
                  className={styles.content}
                  dangerouslySetInnerHTML={{ __html: loginData.field_details }}
                >
                </div>
                <h1 className={styles.head1}>Your Request ID is {orderid} and Go live date is {livedate}</h1>
                <div className={styles.content}>
                <p className={styles.text1}>Engagement lead will reach out to you to discuss your requirement</p>
                <p  className={styles.text1} onClick={() => goTo(props.pageRoutes.Orderlisting)} style={{cursor:"pointer",color:"#1f36d2"}}>Click here to check the Order Status</p>          
      </div>
              </div>
            </div>

            <div className={styles.bottom}>
              <button className={styles.lovedbtn}  onClick={() => goTo(props.pageRoutes.Employeetwin)}>Love It</button>
              <button className={styles.betterbtn}  onClick={() => {openpopup()}}>Can Be Better</button>
            </div>
            {
              feedbackModal ? (
                <Feedbackmodal
                  data={props.feedback.data.field_component}
                  closeModal={() => {
                    setFeedbackModal(false);
                  }}
                  pageRoutes={props.pageRoutes}
                  setSuccessModal={setSuccessModal}
                  setMessage={setMessage}
                  setsucessOrFailure={setsucessOrFailure}
                  empid={empid}
                />
              ) : null
      }
      {
        successModal ? (
          <SuccessModal
            setSuccessModal={setSuccessModal}
            title={"Feedback"}
            message={message}
            fail={sucessOrFailure}
          />
        ) : null
      } 

          </div>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => {
  return {};
};

function mapDispatchToProps(dispatch) {
 
}

export default connect(mapStateToProps, null)(index);

